import React, { useContext, } from 'react';
import { Button, Tooltip, } from 'antd';
import { DeleteOutlined, } from '@ant-design/icons';
import { PermissionsContext } from '../../../../router/DashboardRoutes';

export const DeleteDeviceButton = ({pending, ...props}) => {

    const userPermissions = useContext(PermissionsContext);
    const allowDelete = userPermissions.device.delete;

    const btnSize = 'default';

    return (
        <>
            { allowDelete &&
                ( pending ? 
                    <Tooltip title="Device can't be deleted. Pending changes must be cleared.">
                        <Button size={btnSize} danger disabled={true} type="primary" icon={<DeleteOutlined/>}/>
                    </Tooltip> 
                : 
                    <Button size={btnSize} danger type="primary" icon={<DeleteOutlined/>} onClick={props.onClick || undefined}/>
                )
            }
        </>
    )
}

DeleteDeviceButton.defaultProps = {
    pending: true, 
}